import { baseUrl, get } from './api_service';
import { getTokens } from './auth_service';
import { Integrations } from '../models/integrations'
export const baseAgriWebbUrl = `${baseUrl}`;

export async function getCurrentUserIntegrations(): Promise<Integrations | undefined> {
  const response = await get(`${baseUrl}/integrations`, getTokens().token);
  return response;
}